(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tlg-vacation-notice"] && !Shopify.designMode) return;
  try {
    
  customElements.whenDefined('dialog-element').then(() => {
    if (customElements.get('tlg-vacation-notice')) {
      return;
    }

    const DialogElement = customElements.get('dialog-element');

    customElements.define('tlg-vacation-notice', class extends DialogElement {
      #pendingForm = null;
      #pendingSubmitter = null;
      #pendingClickTarget = null;
      #suppressClick = false;

      connectedCallback() {
        super.connectedCallback();
        document.addEventListener('submit', this.#onCheckoutSubmit, { capture: true, signal: this._abortController.signal });
        document.addEventListener('click', this.#onAppCheckoutClick, { capture: true, signal: this._abortController.signal });
        this.addEventListener('click', this.#onBackdropClick, { signal: this._abortController.signal });
      }

      get initialFocus() {
        return false;
      }

      get shouldLock() {
        return true;
      }

      get shouldAppendToBody() {
        return true;
      }

      hide() {
        this.#resumeCheckout();
        return super.hide();
      }

      #onBackdropClick = (event) => {
        if (event.target === this) {
          this.hide();
        }
      };

      #onCheckoutSubmit = (event) => {
        if (event.submitter?.name !== 'checkout' || event.target.hasAttribute('data-tlg-vacation-acknowledged')) {
          return;
        }

        if (this.hasAttribute('only-once') && sessionStorage.getItem('tlg:vacation-notice-shown') === 'true') {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        this.#pendingForm = event.target;
        this.#pendingSubmitter = event.submitter;

        sessionStorage.setItem('tlg:vacation-notice-shown', 'true');
        this.show();
      };

      // Botones de checkout de apps (ej. AMP Slide Cart Drawer): no son submit de
      // formulario, la app navega por JS, asi que se intercepta el click en captura.
      #onAppCheckoutClick = (event) => {
        const selectors = this.getAttribute('extra-checkout-selectors');

        if (!selectors || this.#suppressClick || !(event.target instanceof Element)) {
          return;
        }

        let target = null;

        try {
          target = event.target.closest(selectors);
        } catch (error) {
          return;
        }

        if (!target) {
          return;
        }

        if (this.hasAttribute('only-once') && sessionStorage.getItem('tlg:vacation-notice-shown') === 'true') {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        this.#pendingClickTarget = target;

        sessionStorage.setItem('tlg:vacation-notice-shown', 'true');
        this.show();
      };

      #resumeCheckout() {
        const form = this.#pendingForm;
        const submitter = this.#pendingSubmitter;
        const clickTarget = this.#pendingClickTarget;

        this.#pendingForm = null;
        this.#pendingSubmitter = null;
        this.#pendingClickTarget = null;

        if (form && form.isConnected) {
          form.setAttribute('data-tlg-vacation-acknowledged', '');

          if (typeof form.requestSubmit === 'function' && submitter?.isConnected) {
            form.requestSubmit(submitter);
          } else {
            const checkoutInput = document.createElement('input');
            checkoutInput.type = 'hidden';
            checkoutInput.name = 'checkout';
            form.appendChild(checkoutInput);
            form.submit();
          }

          return;
        }

        if (clickTarget) {
          if (clickTarget.isConnected) {
            this.#suppressClick = true;
            clickTarget.click();
            this.#suppressClick = false;
          } else {
            window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'checkout';
          }
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
